import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_ACCOUNT_FORM_REQUEST = `${app.NS}account/save_account_form_request`;
export const SAVE_ACCOUNT_FORM_REQUEST_ACTION = createAction(
  SAVE_ACCOUNT_FORM_REQUEST
);
const SAVE_ACCOUNT_FORM_SUCCESS = `${app.NS}account/save_account_form_success`;
export const SAVE_ACCOUNT_FORM_SUCCESS_ACTION = createAction(
  SAVE_ACCOUNT_FORM_SUCCESS
);
const SAVE_ACCOUNT_FORM_FAILURE = `${app.NS}account/save_account_form_failure`;
export const SAVE_ACCOUNT_FORM_FAILURE_ACTION = createAction(
  SAVE_ACCOUNT_FORM_FAILURE
);

export const saveAccountFormRequest = id => {
  const action = SAVE_ACCOUNT_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveAccountFormSuccess = user => {
  const action = SAVE_ACCOUNT_FORM_SUCCESS_ACTION(user);
  return action;
};

export const saveAccountFormFailure = error => {
  const action = SAVE_ACCOUNT_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/account.js